// extracted by css-extract-rspack-plugin
export default {"Heatmap":"Heatmap--dccdZ Chart--xcv6X","HeatmapGroups":"HeatmapGroups--reJuE"};